export const TILE_CHARACTERS = {
  2: "🐰",
  4: "🐱",
  8: "🐶",
  16: "🐻",
  32: "🦊",
  64: "🐼",
  128: "🦁",
  256: "🐯",
  512: "🐧",
  1024: "🦄",
  2048: "👑",
  4096: "🌟",
  8192: "🌈"
};

// 🎓 詳細遊玩教學
export const TUTORIAL_SECTIONS = [
  {
    id: 'basic',
    title: '🎮 基本操作',
    items: [
      {
        icon: '👆',
        title: '如何移動',
        text: '手機：上下左右滑動螢幕\n電腦：使用方向鍵 ↑↓←→ 或拖曳滑鼠'
      },
      {
        icon: '🔄',
        title: '方塊移動規則',
        text: '所有方塊會朝您選擇的方向移動，直到碰到邊緣或其他方塊為止'
      }
    ]
  },
  {
    id: 'merge',
    title: '❤️ 合成系統',
    items: [
      {
        icon: '➕',
        title: '相同合成',
        text: '兩個相同數字的動物碰撞時會合成為下一級\n例如：🐰(2) + 🐰(2) = 🐱(4)'
      },
      {
        icon: '🎯',
        title: '終極目標',
        text: '持續合成直到達成 2048 (👑)！但遊戲不會結束，您可以繼續挑戰更高分數'
      }
    ]
  },
  {
    id: 'scoring',
    title: '📊 計分規則',
    items: [
      {
        icon: '💯',
        title: '合成得分',
        text: '每次合成獲得的分數 = 新方塊的數值\n例如：合成出 64 的方塊，獲得 64 分'
      },
      {
        icon: '🏆',
        title: '高分策略',
        text: '優先合成高數值方塊可以獲得更多分數！一次合成 2048 = 2048 分'
      }
    ]
  },
  {
    id: 'strategy',
    title: '🧠 進階技巧',
    items: [
      {
        icon: '📐',
        title: '角落策略',
        text: '將最大的方塊固定在一個角落，其他方塊圍繞它排列，可以避免混亂'
      },
      {
        icon: '🔗',
        title: '連鎖合成',
        text: '規劃好移動順序，一次移動觸發多個合成，可以快速清理棋盤'
      },
      {
        icon: '⚠️',
        title: '避免填滿',
        text: '盡量保持棋盤有空位，一旦填滿且無法合成，遊戲就會結束'
      }
    ]
  }
];

// 🏆 擴充成就系統（分級設計）
export const ACHIEVEMENTS_LIST = [
  // 🌱 新手成就
  {
    id: 'first_merge',
    name: '初次合成',
    description: '完成第一次方塊合成',
    icon: '🌱',
    tier: 'beginner',
    condition: (state) => state.stats.merges >= 1
  },
  {
    id: 'reach_8',
    name: '萌力初現',
    description: '第一次合成到 8 (🐶)',
    icon: '🐶',
    tier: 'beginner',
    condition: (state) => state.maxTile >= 8
  },
  {
    id: 'score_500',
    name: '入門玩家',
    description: '單局獲得 500 分',
    icon: '🎯',
    tier: 'beginner',
    condition: (state) => state.score >= 500
  },
  {
    id: 'moves_50',
    name: '堅持不懈',
    description: '單局進行 50 次移動',
    icon: '⏱️',
    tier: 'beginner',
    condition: (state) => state.moves >= 50
  },

  // 🔥 進階成就
  {
    id: 'reach_128',
    name: '獅王降臨',
    description: '合成到 128 (🦁)',
    icon: '🦁',
    tier: 'advanced',
    condition: (state) => state.maxTile >= 128
  },
  {
    id: 'score_3000',
    name: '高分達人',
    description: '單局獲得 3000 分',
    icon: '💎',
    tier: 'advanced',
    condition: (state) => state.score >= 3000
  },
  {
    id: 'merges_100',
    name: '合成大師',
    description: '單局完成 100 次合成',
    icon: '🔗',
    tier: 'advanced',
    condition: (state) => state.stats.merges >= 100
  },
  {
    id: 'reach_512',
    name: '企鵝帝國',
    description: '合成到 512 (🐧)',
    icon: '🐧',
    tier: 'advanced',
    condition: (state) => state.maxTile >= 512
  },
  {
    id: 'moves_200',
    name: '馬拉松選手',
    description: '單局進行 200 次移動',
    icon: '🏃',
    tier: 'advanced',
    condition: (state) => state.moves >= 200
  },

  // 👑 大師成就
  {
    id: 'reach_2048',
    name: '萌力至尊',
    description: '達成終極目標 2048 (👑)',
    icon: '👑',
    tier: 'master',
    condition: (state) => state.maxTile >= 2048
  },
  {
    id: 'score_10000',
    name: '傳奇玩家',
    description: '單局獲得 10000 分',
    icon: '🌟',
    tier: 'master',
    condition: (state) => state.score >= 10000
  },
  {
    id: 'reach_4096',
    name: '超越極限',
    description: '合成到 4096 (🌟)',
    icon: '✨',
    tier: 'master',
    condition: (state) => state.maxTile >= 4096
  },
  {
    id: 'efficiency_master',
    name: '效率專家',
    description: '用少於 300 步達到 2048',
    icon: '⚡',
    tier: 'master',
    condition: (state) => state.maxTile >= 2048 && state.moves < 300
  }
];

// 成就分級標籤
export const ACHIEVEMENT_TIERS = {
  beginner: { label: '新手成就', color: 'bg-green-100 text-green-600', icon: '🌱' },
  advanced: { label: '進階成就', color: 'bg-orange-100 text-orange-600', icon: '🔥' },
  master: { label: '大師成就', color: 'bg-purple-100 text-purple-600', icon: '👑' }
};